export interface AccountState {
  id: number;
  email: string;
}

export const initialState: AccountState = {
  id: null,
  email: null
};
